import React from "react";
import styles from "./Button.module.scss";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

const cx = classNames.bind(styles);

function Button({
  to,
  href,
  content,
  primary = false,
  second = false,
  onClick,
  disabled = false,
  type = "button",
  className,
  ...passProps
}) {

  let Comp = 'button';
  const props = {
    onClick,

    ...passProps,
  }

  // Remove event listener when btn is disabled
  if (disabled) {
    // delete props.onClick;
    Object.keys(props).forEach(key => {
      if (key.startsWith('on') && typeof props[key] === 'function') {
        delete props[key]
      }
    })
  }

  if (to) {
    props.to = to
    Comp = Link
  } else if (href) {
    props.href = href
    Comp = 'a'
  }
  const classes = cx("btn", {
    primary,
    second,
    [className]: className
  });

  return (
    <Comp
      className={classes}
      onClick={onClick}
      disabled={disabled}
      type={type}
      {...props}
    >
      {content}
    </Comp>
  );
}

export default Button;